import { CustomerViewModel } from '@bhtp-client-web/component';

export class CustomerSimpleData extends CustomerViewModel { }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/customer-simple-data.model.ts